/** Major Indian banks — public, private, small finance, payments & foreign (RBI scheduled). */
export const INDIAN_BANKS = [
  'Airtel Payments Bank',
  'American Express Banking Corp',
  'AU Small Finance Bank',
  'Axis Bank',
  'Bandhan Bank',
  'Bank of Baroda',
  'Bank of India',
  'Bank of Maharashtra',
  'Barclays Bank',
  'Canara Bank',
  'Capital Small Finance Bank',
  'Central Bank of India',
  'Citibank',
  'City Union Bank',
  'CSB Bank',
  'DBS Bank India',
  'DCB Bank',
  'Deutsche Bank',
  'Dhanlaxmi Bank',
  'Equitas Small Finance Bank',
  'ESAF Small Finance Bank',
  'Federal Bank',
  'Fincare Small Finance Bank',
  'Fino Payments Bank',
  'HDFC Bank',
  'HSBC',
  'ICICI Bank',
  'IDBI Bank',
  'IDFC FIRST Bank',
  'India Post Payments Bank',
  'Indian Bank',
  'Indian Overseas Bank',
  'IndusInd Bank',
  'Jammu & Kashmir Bank',
  'Jana Small Finance Bank',
  'Jio Payments Bank',
  'Karnataka Bank',
  'Karur Vysya Bank',
  'Kotak Mahindra Bank',
  'Nainital Bank',
  'North East Small Finance Bank',
  'NSDL Payments Bank',
  'Paytm Payments Bank',
  'Punjab & Sind Bank',
  'Punjab National Bank',
  'RBL Bank',
  'Shivalik Small Finance Bank',
  'South Indian Bank',
  'Standard Chartered Bank',
  'State Bank of India',
  'Suryoday Small Finance Bank',
  'Tamilnad Mercantile Bank',
  'UCO Bank',
  'Ujjivan Small Finance Bank',
  'Union Bank of India',
  'Unity Small Finance Bank',
  'Yes Bank',
].sort((a, b) => a.localeCompare(b, 'en', { sensitivity: 'base' }));
